import Script from "next/script";

import type { ExternalWidgetVentrata as ExternalWidgetVentrataType } from "../../types/ExternalWidget";

export type ExternalWidgetVentrataContentProps = Pick<ExternalWidgetVentrataType, "apiKey">;

export function ExternalWidgetVentrataContent({ apiKey }: ExternalWidgetVentrataContentProps) {
    const env = process.env.NODE_ENV === "production" ? "live" : "test";
    const scriptDataConfig = { apiKey, env };

    return (
        <>
            {apiKey ? (
                <Script
                    src="https://cdn.checkout.ventrata.com/v3/production/ventrata-checkout.min.js"
                    type="module"
                    data-config={JSON.stringify(scriptDataConfig)}
                />
            ) : null}
        </>
    );
}
